import React from "react";

function Contact() {
  return (
    <div className="relative bg-white min-h-screen font-poppins pt-[160px]">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-grid-gray/[0.05] bg-[size:60px_60px]"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#D82F2F]/5 via-transparent to-[#D82F2F]/5"></div>
      </div>

      <div className="relative container mx-auto px-6 py-16">
        {/* Header Section */}
        <div className="text-center mb-20">
          <div className="inline-block">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4 relative">
              Contact Us
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D82F2F] to-transparent"></div>
            </h1>
          </div>
          <p className="text-gray-600 mt-6 text-lg max-w-2xl mx-auto leading-relaxed">
            We're here to assist you with all your industrial gas needs. Reach out to us through any of the following channels.
          </p>
        </div>

        {/* Contact Information Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Phone Numbers */}
          <div className="relative group transform transition-all duration-300 hover:-translate-y-2">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#D82F2F] to-[#D82F2F]/80 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
            <div className="relative bg-white border border-[#D82F2F]/20 rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-[#D82F2F]/10 rounded-lg">
                  <svg className="w-8 h-8 text-[#D82F2F]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 ml-4">Call Us</h3>
              </div>
              <div className="space-y-4">
                <a href="tel:+918299204736" className="group/link flex items-center text-gray-700 hover:text-[#D82F2F] transition-colors duration-300">
                  <span className="text-lg group-hover/link:translate-x-2 transition-transform duration-300">+91 8299204736</span>
                </a>
                <a href="tel:+919119117385" className="group/link flex items-center text-gray-700 hover:text-[#D82F2F] transition-colors duration-300">
                  <span className="text-lg group-hover/link:translate-x-2 transition-transform duration-300">+91 9119117385</span>
                </a>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="relative group transform transition-all duration-300 hover:-translate-y-2">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#D82F2F] to-[#D82F2F]/80 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
            <div className="relative bg-white border border-[#D82F2F]/20 rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-[#D82F2F]/10 rounded-lg">
                  <svg className="w-8 h-8 text-[#D82F2F]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 ml-4">Email Us</h3>
              </div>
              <a href="mailto:trivenigases10@gmail.com" className="group/link flex items-center text-gray-700 hover:text-[#D82F2F] transition-colors duration-300">
                <span className="text-lg group-hover/link:translate-x-2 transition-transform duration-300">trivenigases10@gmail.com</span>
              </a>
            </div>
          </div>

          {/* Address */}
          <div className="relative group transform transition-all duration-300 hover:-translate-y-2">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#D82F2F] to-[#D82F2F]/80 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
            <div className="relative bg-white border border-[#D82F2F]/20 rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-[#D82F2F]/10 rounded-lg">
                  <svg className="w-8 h-8 text-[#D82F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 ml-4">Visit Us</h3>
              </div>
              <p className="text-lg text-gray-700">
                53/38 Bai Ka Bagh, <br />
                Prayagraj, Uttar Pradesh
              </p>
            </div>
          </div>
        </div>

        {/* Business Hours */}
        <div className="mb-16">
          <div className="max-w-3xl mx-auto relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#D82F2F] to-[#D82F2F]/80 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
            <div className="relative bg-white border border-[#D82F2F]/20 rounded-xl p-8 shadow-lg text-center">
              <div className="flex items-center justify-center mb-6">
                <div className="p-3 bg-[#D82F2F]/10 rounded-lg">
                  <svg className="w-8 h-8 text-[#D82F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 ml-4">Business Hours</h3>
              </div>
              <div className="space-y-2 text-lg">
                <p className="text-gray-700">
                  <span className="text-[#D82F2F] font-medium">Monday - Saturday:</span> 10:30 AM - 8:00 PM
                </p>
                <p className="text-gray-700">
                  <span className="text-[#D82F2F] font-medium">Sunday:</span> Closed
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps */}
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-[#D82F2F] to-[#D82F2F]/80 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
          <div className="relative bg-white border border-[#D82F2F]/20 rounded-xl p-2 shadow-lg">
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.3657504700635!2d81.84774937538826!3d25.45175947785814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acb2d5177f58f%3A0x45a6e3c4c378d0d7!2sTriveni%20Industrial%20Gases!5e0!3m2!1sen!2sin!4v1709799171599!5m2!1sen!2sin"
                className="w-full h-[500px] rounded-lg"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
